import analyticsDb from "@/pixels/analyticsDb";

describe("analyticsDb config", () => {
  it("configuracion exportada por defecto", () => {
    expect(analyticsDb).toBeDefined();
    expect(analyticsDb).not.toBeNull();
    expect(typeof analyticsDb).toBe("object");
  });
});
